import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create DeleteVariation action
 */
export function createAddCommentBefore(
  store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.InsertCommentBefore,
    action: CONTEXT_MENU_ACTION_NAMES.AddCommentBefore,
    isVisible,
    handler,
  };

  /**
   * visible on first nodes with no initComment
   */
  function isVisible({ node, game }: ContextMenu.ActionHandlerContext) {
    const lines = game.getRawLines();
    const line = lines[node.ids.line];
    const isFirstNode = node.ids.move === 0;
    const initCommentExists = line.initComment !== undefined;
    const isEditable = store.commentsEditable.get();

    return isFirstNode && !initCommentExists && isEditable;
  }

  /**
   * handler to add comment before
   */
  function handler({ node, game }): void {
    game.updateLineComment('', node.ids.line);
  }
}
